import useAIToolsCanvasStore from '@/store/useAIToolsCanvasStore';
import { PathBrush } from '@meitu/whee-infinite-canvas';
import { blobToFile, uploadFileBeforeEditor } from '$/utils/upload';

/**
   * 导出 mask 为 Blob // todo-xm exportMask 只要调用就是最终的结果，还需要上传
   */
export async function exportMaskBlob(): Promise<Blob | null> {
  const { render, imageTarget } = useAIToolsCanvasStore.getState();
  if (!render) return null;
  const activeBrush = render._FC.freeDrawingBrush as PathBrush | undefined;
  if (!activeBrush || !imageTarget) return null;

  const scaleWidth = imageTarget.getScaledWidth();
  const scaleHeight = imageTarget.getScaledHeight();
  console.log('imageTarget', imageTarget.width, imageTarget.height);
  console.log('scaleWidth', scaleWidth, 'scaleHeight', scaleHeight);

  const blobs = await activeBrush.exportShapesToBlob({
    isMerge: true,
    ext: 'png',
    shapeFill: '#ffffff',
    backgroundFill: '#000000',
    exportContainerType: 'eraser_mask_container',
    size: { width: Math.round(scaleWidth), height: Math.round(scaleHeight) },
  });

  if (!blobs?.length) return null;
  return blobs[0];
}

/**
 * @description 校验 mask 图片是否有效：所有像素均为纯黑(#000000)则视为无效，存在任意非黑色像素则有效
 * @param {string} url - mask 图片的 URL
 * @returns {Promise<boolean>} 存在非黑色像素返回 true，否则返回 false
 */
export function checkMaskUrlCorrec(url: string): Promise<boolean> {
  return new Promise((resolve) => {
    if (!url) {
      resolve(false);
      return;
    }
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        resolve(false);
        return;
      }
      ctx.drawImage(img, 0, 0);
      const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
      for (let i = 0; i < data.length; i += 4) {
        if (data[i] > 0 || data[i + 1] > 0 || data[i + 2] > 0) {
          resolve(true);
          return;
        }
      }
      resolve(false);
    };
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

/**
 * @description 导出 mask 并上传，返回上传后的 URL
 * @returns {Promise<string | null>} 上传成功返回 URL，无 mask 时返回 null
 */
export async function exportMaskUrl(): Promise<string | null> {
  const blob = await exportMaskBlob();
  if (!blob) return null;

  const maskFile = blobToFile(blob, 'mask.png');
  const uploadData = await uploadFileBeforeEditor([maskFile]);
  return uploadData[0]?.url || null;
}
